// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3e9tn","head":"ProcedureTableInfo_head__2LycG"};